import { render, staticRenderFns } from "./ConsumerDashboardNavbar.vue?vue&type=template&id=67a5093d&"
import script from "./ConsumerDashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports